import React from 'react'
import { usePlatforms } from '../../contexts/PlatformsContext'
import metalogo from '../../assets/images/meta-logo.png'

const PlatformIcon = ({ platform, size = 16, showLabel = false }) => {
  const { getPlatformById, normalizePlatformName, loading } = usePlatforms()

  if (loading) {
    return <span className="platform-icon loading">...</span>
  }

  const normalizedPlatformId = normalizePlatformName(platform)
  const platformData = getPlatformById(normalizedPlatformId)

  if (platformData) {
    return (
      <span className="platform-icon" aria-label={platformData.display_name}>
        <img src={platformData.icon_url} alt={platformData.display_name} style={{ height: size }} />
        {showLabel && <span className="platform-label">{platformData.display_name}</span>}
      </span>
    )
  }

  // Fallback to hardcoded values for backwards compatibility
  const p = (platform || '').toLowerCase();

  if (p === 'meta' || p === 'oculus' || p === 'quest') {
    return (
      <span className="platform-icon" aria-label="Meta">
        <img src={metalogo} alt="Meta" style={{ height: size }} />
        {showLabel && <span className="platform-label">Meta</span>}
      </span>
    )
  }

  if (p === 'steam') {
    return (
      <span className="platform-icon" aria-label="Steam">
        <i className="fa-brands fa-steam" aria-hidden style={{ marginRight: 6 }}></i>
        {showLabel && <span className="platform-label">Steam</span>}
      </span>
    )
  }

  if (p === 'apple_vision' || p === 'apple vision' || p === 'vision pro' || p === 'visionos') {
    return (
      <span className="platform-icon" aria-label="Apple Vision">
        <i className="fa-brands fa-apple" aria-hidden style={{ marginRight: 6 }}></i>
        {showLabel && <span className="platform-label">Apple Vision</span>}
      </span>
    )
  }

  return <span className="platform-icon">{showLabel ? platform : platform}</span>
}

export default PlatformIcon
